/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  MetaCategorySuggestionControllerEnqueueMutationRequest,
  MetaCategorySuggestionControllerEnqueueMutationResponse,
  MetaCategorySuggestionControllerEnqueuePathParams,
  MetaCategorySuggestionControllerEnqueue401,
} from '../types/MetaCategorySuggestionControllerEnqueue.ts';

function getMetaCategorySuggestionEnqueueUrl(
  metaCategoryId: MetaCategorySuggestionControllerEnqueuePathParams['metaCategoryId'],
) {
  const res = { method: 'POST', url: `/api/user/telegram/category/meta/${metaCategoryId}/suggestions/queue` as const };
  return res;
}

/**
 * {@link /api/user/telegram/category/meta/:metaCategoryId/suggestions/queue}
 */
export async function metaCategorySuggestionEnqueue(
  metaCategoryId: MetaCategorySuggestionControllerEnqueuePathParams['metaCategoryId'],
  data: MetaCategorySuggestionControllerEnqueueMutationRequest,
  config: Partial<RequestConfig<MetaCategorySuggestionControllerEnqueueMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    MetaCategorySuggestionControllerEnqueueMutationResponse,
    ResponseErrorConfig<MetaCategorySuggestionControllerEnqueue401>,
    MetaCategorySuggestionControllerEnqueueMutationRequest
  >({
    method: 'POST',
    url: getMetaCategorySuggestionEnqueueUrl(metaCategoryId).url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
